import { Component, OnDestroy, ViewChild, Input, AfterViewInit } from '@angular/core';
import { NgForm } from '@angular/forms';

declare var $: any;
declare var Toast: any;

@Component({
  selector: 'show-campaign-message',
  templateUrl: './show-campaign-message.component.html',
  styleUrls: ['./show-campaign-message.component.css']
})

export class ShowCampaignMessageComponent implements AfterViewInit, OnDestroy {
  private message: ShowMessage = new ShowMessage();
  private modal: any;

  @ViewChild('msgForm', { static: false }) msgForm: NgForm;
  @Input() private modalId: number;

  constructor() { }

  ngAfterViewInit() {
    this.modal = $('#showMessageForm-' + this.modalId);
  }

  public show(message: ShowMessage) {
    this.msgForm.reset();
    this.message = message;

    this.modal.modal({
      show: true,
      backdrop: 'static',
      keyboard: false
    });
  }

  close() {
    this.modal.modal('hide');
    this.msgForm.reset();
    this.message = new ShowMessage();
  }

  ngOnDestroy() {
    this.message = new ShowMessage();
  }
}

export class ShowMessage {
  id: number;
  recepient: string;
  content: string;
}
